import { isValidPhoneNumber } from 'react-phone-number-input';

const LAUNCH_EMAIL_MAX = 254;

export function isValidLaunchEmail(email) {
    if (typeof email !== 'string') return false;
    const t = email.trim();
    if (!t || t.length > LAUNCH_EMAIL_MAX) return false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)) return false;
    const local = t.split('@')[0] || '';
    if (local.includes('..')) return false;
    return true;
}

export function isValidLaunchPhone(phone) {
    if (!phone || typeof phone !== 'string') return false;
    return isValidPhoneNumber(phone.trim());
}
